"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyInviteUserV1WorkspaceInvitesAddPostWorkspacePermission = void 0;
exports.BodyInviteUserV1WorkspaceInvitesAddPostWorkspacePermission = {
    External: "external",
    Admin: "admin",
    WorkspaceAdmin: "workspace_admin",
    WorkspaceMember: "workspace_member",
    SupportL1: "support_l1",
    SupportL2: "support_l2",
    Moderator: "moderator",
    Sales: "sales",
    VoiceMixer: "voice_mixer",
    VoiceAdmin: "voice_admin",
    ConvaiAdmin: "convai_admin",
    EnterpriseViewer: "enterprise_viewer",
    QualityCheckAdmin: "quality_check_admin",
    WorkspaceMigrationAdmin: "workspace_migration_admin",
    HumanReviewer: "human_reviewer",
    ProductionsAdmin: "productions_admin",
    Support: "support",
    Internal: "internal",
};
